const SearchBoxShare = {
  getSearchParaForMultiCity (searchPara) {
    
    var fnc = ap => {
      try {
          var code = ap.split('-')[0];
          code = code.trim();
          var place = ap.split('-')[1];
          place = place.trim();
          return [code,place];            
      } catch (error) {
          return ["",""]
      }
    }
  var origin=[];
  var destination=[];
  var departureDate=[];
  var airportOfOriginM=[];
  var airportOfDestinationM=[];

  if (searchPara.originM.length > 0){
          var items1 = searchPara.originM;
              items1.forEach((al)=>{
                  let ori=fnc(al);
                      origin.push(ori[0]);
                      airportOfOriginM.push(ori[1]);
              });
      }
  if (searchPara.destinationM.length > 0){
          var items2 = searchPara.destinationM;
              items2.forEach((al)=>{
                  let dest=fnc(al);
                      destination.push(dest[0]);
                      airportOfDestinationM.push(dest[1]);
              });
      }
  if (searchPara.departureDateM.length > 0){
          var items3 = searchPara.departureDateM;
              items3.forEach((al)=>{
                      departureDate.push(al==null?'': al.replace(/-/g,''))
              });
      }

  var para = {
      WholesaleId:searchPara.wholesaleId,
      UrlId:searchPara.urlId,
      Trip:"M",
      Airline:searchPara.airline==""?"--":searchPara.airline,
      OriginM: origin,
      DestinationM:destination,
      DepartureDateM:departureDate,
      Class:searchPara.seatClass,
      AdtPassengerCount:searchPara.adtPassengerCount,
      CnnPassengerCount:searchPara.cnnPassengerCount,
      InfPassengerCount:searchPara.infPassengerCount,
      StuPassengerCount:searchPara.stuPassengerCount,
      MarkupLevel:searchPara.markupLevel,
      StyleName:searchPara.styleName,
      Language:searchPara.language,
      AirportOfOriginM:airportOfOriginM,
      AirportOfDestinationM:airportOfDestinationM,
      FlightType:searchPara.flightType        
  };
  
  return para;
  },
  getPassengerCounts(c){
    this.searchPara.adtPassengerCount = c.adt;
    this.searchPara.cnnPassengerCount = c.cnn;
    this.searchPara.infPassengerCount = c.inf;
    this.$emit('PassengerCountsByType',{
        adultCount:c.adt,
        childCount:c.cnn,
        infantCount:c.inf
    })
  }
};

export default SearchBoxShare;